export interface Coordinates {
  lat: number
  lng: number
  accuracy?: number
}

/**
 * Time-boxed capture of the device's current coordinates.
 * Captured only once on demand at clock-in / clock-out or task verification.
 * Never runs continuous background tracking.
 */
export const readCurrentCoordinates = async (
  options: { timeoutMs?: number; enableHighAccuracy?: boolean } = {},
): Promise<Coordinates | null> => {
  if (typeof navigator === 'undefined' || !navigator.geolocation) return null
  const { timeoutMs = 12_000, enableHighAccuracy = true } = options
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
        }),
      () => resolve(null),
      { enableHighAccuracy, timeout: timeoutMs },
    )
  })
}
